import React, {useState, useEffect} from "react";
import "./Header.less";
import HeaderMenu from "./HeaderMenu";
import HeaderLogo from "./HeaderLogo";
import HeaderButtons from "./HeaderButtons";

function Header() {
    const [showDesktopMenu, setShowDesktopMenu] = useState(true);
    const [showMobileMenu, setShowMobileMenu] = useState(false);

    useEffect(() => {
        let window_width = window.innerWidth;
        if (window_width > 1429) {
            setShowDesktopMenu(true);
        } else {
            setShowDesktopMenu(false);
        }
    }, []);

    function toggleMobileMenu() {
        setShowMobileMenu(prev => !prev);
    }

    return (
        <header className="gg-header">
            <div className="container-full">
                <div className="gg-header-content row no-padding align-items-center">
                    <HeaderLogo activeButton={showMobileMenu} toggleMenu={toggleMobileMenu}/>
                    <HeaderMenu showDeskMenu={showDesktopMenu} showMobMenu={showMobileMenu} />
                    <HeaderButtons/>
                </div>
            </div>
        </header>
    )
}

export default Header;